import { network } from "./index";
import { AtticusForm, FormJson } from "models/AtticusForm";
import { Estate } from "models/Estate";
import { EstateFormMap } from "models/EstateFormMap";
import { GeographyJson } from "models/Geography";

export class EstateFormsAPI {
  async getEstateForms(
    estateId: number,
    rethrowError = false
  ): Promise<AtticusForm[]> {
    const fullPath = `${Estate.path}/${estateId}/forms`;
    const response = await network.callGet(fullPath, rethrowError);
    const forms: AtticusForm[] = [];
    response?.data?.forEach((formJson: FormJson) => {
      forms.push(AtticusForm.fromJSON(formJson));
    });

    return forms;
  }

  async addFormToEstate(
    estateId: number,
    form: AtticusForm,
    rethrowError = false
  ): Promise<AtticusForm> {
    const fullPath = `${Estate.path}/${estateId}/forms/${form.id}`;
    const response = await network.callPost(fullPath, undefined, rethrowError);
    if (response?.data) {
      const estateFormMap = EstateFormMap.fromJSON(response?.data);
      const copiedForm = AtticusForm.from(form);
      copiedForm.estateFormMap = estateFormMap;
      return copiedForm;
    } else {
      throw Error("Estate Form addition failed");
    }
  }

  async removeFormFromEstate(
    estateId: number,
    form: AtticusForm,
    rethrowError = false
  ): Promise<boolean> {
    const fullPath = `${Estate.path}/${estateId}/forms/${form.id}`;
    const response = await network.callDelete(fullPath, rethrowError);
    if (response?.data) {
      return true;
    } else {
      throw Error("Estate Form removal failed");
    }
  }

  async getRecommendedFormsForEstate(estateId: number, rethrowError = false): Promise<{ percentMatch: number, form: AtticusForm, formGeography:GeographyJson}[]> {
    const fullPath = `${Estate.path}/${estateId}/forms/recommended`
    const response = await network.callGet(fullPath, rethrowError)
    if(!response?.data) {
      return []
    }

    const forms: { percentMatch: number, form: AtticusForm, formGeography:GeographyJson}[] = []
    const dataValues = (Object.values(response?.data) || []) as {percent_match:number, form:FormJson, form_geography:GeographyJson[]}[]
    dataValues.map(formWithMatch => {
      const formGeography = formWithMatch.form_geography && formWithMatch.form_geography.length > 0 ? formWithMatch.form_geography[0] : {} as GeographyJson
      let form = null;
      try {
        form = AtticusForm.fromJSON(formWithMatch.form)
      } catch(e) {}
      if(!form) {
        return
      }

      forms.push({percentMatch: formWithMatch.percent_match, form, formGeography})
    })
    forms.sort((a,b) => {
      // Put asset transfer forms first
      if(a.form.formTypeId === 2) {
        return -1
      }

      if(a.percentMatch > b.percentMatch) {
        return -1
      } else if(a.percentMatch < b.percentMatch) {
        return 1
      }

      if(a.form.formTitle > b.form.formTitle) {
        return 1
      } else if(a.form.formTitle < b.form.formTitle) {
        return -1
      }

      return 0
    })

    return forms
  }
}
